import { JSX } from "react";
import "../../App.scss";
import Sidebar from "../../Components/Layout/Sidebar/Sidebar";
import { appContext } from "../../AppContext";
import { IbssPage } from "../../Components/Core/BasePage/IbssPage";
import { Typography } from "@iconics/components";
import "./Styles.scss";

class NoRights extends IbssPage<IProps, IState>
{
    private labels = appContext().labels;

    public componentDidMount(): void
    {
        this.pageTitle = '';
    }

    public render(): JSX.Element
    {
        return (
            <div className="page-container" >
                <Sidebar {...this.props} />
                <div className="rightPanel">
                    <div className="redirectContainer">
                        <div className="card">
                            <Typography role="body" size="large">{this.labels.HubLabelNoRights}</Typography>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NoRights;

export interface IProps { }
export interface IState { }
